/**
 * The page of the API keys and their associated webhooks.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2026
 */

import { fetchApiKeyList } from '@/api'
import { AppRouteUrl } from '@/AppRoute'
import RectRoundButton from '@/components/Button/RectRoundButton'
import { PageNote } from '@/components/PageNote'
import TopBar from '@/components/TopBar'
import { logger } from '@/config/logger'
import { getUserState } from '@/store'
import { ApiKey } from '@amplify3/duplo-back-end'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import ApiKeyComponent from './ApiKeyComponent'
import './ApiKeyWebookPage.css'

const ApiKeyWebhookPage = () => {
  const navigate = useNavigate()
  const { apiKeyList } = useSelector(getUserState)

  return (
    <div className="api-key-webhook-page-container">
      <TopBar
        title="API Keys & Webhooks"
        rightNestedComp={
          <RectRoundButton
            label="+ Add API key"
            id="add-api-key"
            onClick={() => navigate(AppRouteUrl.ApiKeyCreate)}
          />
        }
      />
      <div className="page api-key-webhook-page">
        <PageNote
          message={
            'Webhooks are associated to an API key: ' +
            'each API key has its own list of webhook subscriptions.'
          }
        />

        {apiKeyList?.value && apiKeyList?.value?.length > 0 ? (
          <ApiKeyWebhookList apiKeyList={apiKeyList?.value} />
        ) : (
          <div className="empty-list-message">
            No defined API key. Please create a new one.
          </div>
        )}
      </div>
    </div>
  )
}

interface ApiKeyWebhookListProps {
  apiKeyList?: ApiKey[]
}

const ApiKeyWebhookList = (props: ApiKeyWebhookListProps) => {
  useEffect(() => {
    fetchApiKeyList()
    // fetchWebhooks()
  }, [])

  useEffect(() => {
    logger.info('ApiKeyWebhookList:', props.apiKeyList)
  }, [props.apiKeyList])

  return (
    <div className="api-key-webhook-list">
      {props.apiKeyList?.map((apiKey: ApiKey) => (
        <ApiKeyComponent key={apiKey.client_id} apiKey={apiKey} />
      ))}
    </div>
  )
}

export default ApiKeyWebhookPage
